import { Vue, Component } from 'vue-property-decorator';
import user from '@/store/modules/user';
import router from '@/router';

@Component
export default class CompanyMixin extends Vue {
    get asDoc() {
        return {
            overview: this.overview,
            balance: this.balance,
            profitloss: this.profitloss,
            cashflow: this.cashflow,
            valuation: this.valuation,
            doc: {
                SieAggVersion: 0,
            },
        };
    }

    get isGlobal() {
        return this.orgNr() === '00';
    }

    get overview() {
        if (this.orgNr() === '00') {
            return undefined;
        }
        if (!user.company.overviewLoaded) {
            user.getOverview(this.orgNr());
        }
        return user.company.overview;
    }
    get ranking() {
        if (!user.company.rankingLoaded) {
            user.getRanking(this.orgNr());
        }
        return user.company.ranking;
    }
    get ranking1() {
        if (this.ranking) {
            return this.ranking.sheets[0];
        } else {
            return undefined;
        }
    }
    get balance() {
        if (!user.company.balanceLoaded) {
            user.getBalance(this.orgNr());
        }
        return user.company.balance;
    }
    get balance1() {
        if (this.balance) {
            return this.balance.sheets[0];
        } else {
            return undefined;
        }
    }
    get profitloss() {
        if (!user.company.profitlossLoaded) {
            user.getProfitLoss(this.orgNr());
        }
        return user.company.profitloss;
    }
    get profitloss1() {
        if (this.profitloss) {
            return this.profitloss.sheets[0];
        } else {
            return undefined;
        }
    }
    get cashflow() {
        if (!user.company.cashflowLoaded) {
            user.getCashFlow(this.orgNr());
        }
        return user.company.cashflow;
    }
    get valuation() {
        if (!user.company.valuationLoaded) {
            user.getValuation({orgNr: this.orgNr(), offset: 0});
        }
        return user.company.valuation;
    }
    get sustainability() {
        if (!user.company.sustainabilityLoaded) {
            user.getSustainability(this.orgNr());
        }
        return user.company.sustainability;
    }
    get sies() {
        if (!user.company.siesLoaded) {
            user.getSies(this.orgNr());
        }
        return user.company.sies;
    }
    get documents() {
        if (!user.company.documentsLoaded) {
            user.getDocuments(this.orgNr());
        }
        return user.company.documents;
    }
    get templates() {
        if (!user.templatesLoaded) {
            user.getTemplates();
        }
        return user.templates;
    }
    orgNr() {
        return router.currentRoute.params.OrgNr;
    }
}
